<template lang="pug">
div
  h2.title--separator(class="pb-8 mb-8") Vous ne trouvez pas l'offre qui vous correspond ?
  p(class="my-5 text-17") Renseignez votre adresse email pour être prévenu en avant-première des nouveaux biens correspondant à vos critères de recherche

  div(class="max-w-80% mx-auto")
    div(v-html="alertTags")

  div(v-if="!success")
    form(class="max-w-80% mx-auto mt-10 text-left" @submit.prevent="handleSubmit")
      label Votre e-mail

      div(class="mt-3 mb-5")
        input.form-control(v-model="email" type="email" required="required")

      button.btn.btn-primary(type="submit")
        span Envoyer

      p.text-red.text-9.italic.mt-3 {{ error }}

  div(v-else)
    p.text-primary.font-bold.mt-12
      span  {{ success }}

    .text-center
      a(class="inline-block mt-8 btn btn-primary" @click.prevent="$modal.hide('modal-alert')")
        span Fermer

</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      email: '',
      success: null,
      error: null
    }
  },

  computed: {
    alertTags () {
      return this.$store.getters.getAlertTags
    }
  },

  methods: {
    handleSubmit () {
      axios.post('/alerts', {
        email: this.email,
        params: this.$store.getters.getParams
      })
        .then(response => {
          this.success = "L'alerte a été ajoutée avec succès"
        })
        .catch(() => {
          this.error = "Une erreur s'est produite lors de la création de l'alerte."
        })
    }
  }
}
</script>
